import React from 'react'
import './adminApp.css';
import Sidebar from './components/Sidebar';

export default function adminMyAccounts() {
    return (
        <>
            <div className="txt-container">
                <Sidebar />
                <div>
                    <h1>Admin My Accounts page</h1>
                </div>
            </div>
        </>
    )
}
